import styled from 'styled-components';

export const VideoCard = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  border-radius: ${(props) => (props.store ? '12px' : '8px')};
  box-shadow: ${(props) =>
    props.store ? '0 1px 5px 0 rgba(0, 0, 0, 0.15)' : ''};
  .videoOuter {
    position: relative;
    min-height: ${(props) => (props.store ? '272.2px' : '')};
  }
  video {
    width: 100%;
    border-radius: 8px 8px 0 0;
  }
  .productImg {
    position: absolute;
    bottom: 2%;
    left: 50%;
    transform: translate(-50%, 50%);
    border-radius: 15px;
    width: 33%;
    @media (max-width: 720px) {
      width: 60px;
      border-radius: 8px;
      bottom: 2%;
    }
  }
  flex-basis: 56%;
  flex-shrink: 0;
  .bottomOverlay {
    position: absolute;
    padding: 10px;
    bottom: 4px;
    border-bottom-right-radius: 8px;
    border-bottom-left-radius: 8px;
    width: 100%;
    left: 0;
    background: linear-gradient(to bottom, transparent, rgba(0, 0, 0, 0.78));
    display: flex;
    align-items: center;
    justify-content: space-between;
    img {
      width: 16px;
      &.sound {
        width: 20px;
      }
    }

    .viewCount {
      display: flex;
      align-items: center;
      gap: 6px;
      color: #fff;
      font-size: 14px;
      font-weight: 500;
    }
  }
  .hidden {
    display: none;
  }
  @media (min-width: 768px) {
    flex-basis: ${(props) => (props.store ? '20%' : '37%')};
  }
  &.lowOpacity {
    opacity: 0.4;
  }
`;

export const ProductContainer = styled.div`
  padding-top: 14%;
  min-height: 110px;
  .productDetails {
    padding: 12px 8px 12px;
    .productName {
      font-size: clamp(12px, 2vw, 14px);
      font-weight: 500;
      text-align: center;
      color: rgba(0, 0, 0, 0.87);
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
    }
  }
`;
